import React from 'react';

import { startCase, camelCase } from 'lodash';

export const renderAlertCategory = ({ value }) => {
  return startCase(camelCase(value));
};
